export { default } from "../../components/CDP/Anonymous/Categories";
